// src/components/About/About.js
import React from "react";
import "./About.css";

const About = () => {
  return (
    <section className="about">
      <div className="container">
        <div className="section-title">
          <h5>About Atlas Spaces Real Estate</h5>
          <p>We are committed to providing the best real estate services</p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p>
              Atlas Spaces Real Estate has been serving the community for over
              15 years. We specialize in industrial, land, warehouse and
              commercial properties, helping our clients find their dream
              office, land, warehouse and perfect investment opportunities.
            </p>
            <div className="features-grid">
              <div className="feature">
                <i className="fas fa-home"></i>
                <h4>Property Management</h4>
                <p>
                  Complete property management services for owners and
                  investors.
                </p>
              </div>
              <div className="feature">
                <i className="fas fa-search-dollar"></i>
                <h4>Buy & Sell</h4>
                <p>
                  Expert guidance for buying and selling industrial, warehouse,
                  land and commercial properties.
                </p>
              </div>
              <div className="feature">
                <i className="fas fa-handshake"></i>
                <h4>Consultation</h4>
                <p>
                  Professional real estate consultation and investment advice.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
